<template>
  <div class="faq-form">
    <v-form
      ref="form"
      v-if="form"
      style="max-width: 500px"
      @submit.prevent="onSubmit"
    >
      <v-row v-if="isUpdate">
        <v-col cols="12" sm="6">
          <label class="text-field-label">Status</label>
          <v-text-field
            flat
            solo
            readonly
            hide-details="auto"
            class="mt-2"
            placeholder="Status"
            v-model="faq.status"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <label class="text-field-label">Title</label>
          <v-text-field
            flat
            solo
            required
            hide-details="auto"
            class="mt-2"
            placeholder="Title"
            v-model="form.title"
            :error-messages="form.$getError('title')"
            :loading="form.$busy"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <label class="text-field-label">Content</label>
          <v-textarea
            flat
            solo
            required
            height="350"
            hide-details="auto"
            class="mt-2"
            placeholder="Content"
            v-model="form.text"
            :error-messages="form.$getError('text')"
            :loading="form.$busy"
          ></v-textarea>
        </v-col>
      </v-row>

      <div class="mt-4">
        <v-btn
          type="submit"
          color="primary"
          depressed
          class="mr-4 px-6"
          height="40px"
          :loading="form.$busy"
          >{{ actionLabel }}</v-btn
        >
        <v-btn
          v-if="isUpdate"
          color="red"
          dark
          depressed
          class="mr-4 px-6"
          height="40px"
          @click="deleteDialog = true"
          :loading="form.$busy"
          >Delete</v-btn
        >
      </div>
    </v-form>

    <v-dialog v-if="faq" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete ?</v-card-title>

        <v-card-text>Are you sure you want to delete this FAQ ?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="deleteDialog = false" :loading="form.$busy"
            >Cancel</v-btn
          >

          <v-btn color="red" text @click="onDelete" :loading="form.$busy"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">OK</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import Faq from '@/models/Faq'
import { mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import { mapActions } from 'vuex'
import Form from '@/utils/form'

export default {
  props: {
    faq: {
      type: [Faq, Object]
    }
  },

  data() {
    return {
      icons: {
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },
      deleteDialog: false,
      form: new Form({
        title: null,
        text: null
      }),
      snackbar: {
        show: false,
        message: null,
        color: ''
      }
    }
  },

  computed: {
    submit() {
      return this.isUpdate ? this.updateFaq : this.createFaq
    },

    actionLabel() {
      return this.isUpdate ? 'Update' : 'Save'
    },

    isUpdate() {
      return !!this.faq
    }
  },

  watch: {
    faq(value) {
      this.initForm()
    }
  },

  methods: {
    ...mapActions({
      updateFaq: 'faq/updateFaq',
      createFaq: 'faq/createFaq',
      deleteFaq: 'faq/deleteFaq'
    }),

    initForm() {
      if (this.faq) {
        this.form = new Form(this.faq)
      }
    },

    async onSubmit() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      await this.submit(this.form.$data())
        .then(data => {
          if (this.isUpdate) {
            this.form.$setLoading(false)
            this.showSnackbar('Faq successfully updated!', 'success')
          } else {
            this.$router.push({
              name: 'faq.details',
              params: {
                id: data.data.data.id
              }
            })
          }
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.showSnackbar(this.form.$errorMessage, 'danger')
        })
    },

    async onDelete() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      await this.deleteFaq({
        id: this.faq.id
      })
        .then(() => {
          this.form.$setLoading(false)
          this.deleteDialog = false
          this.showSnackbar('Faq deleted successfully!')
          this.$router.replace('/faqs')
        })
        .catch(error => {
          this.form.$setLoading(false)
          this.form.$handleError(error)
          this.showSnackbar(this.form.$errorMessage, 'danger')
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  },

  mounted() {
    this.initForm()
  }
}
</script>
